import React from 'react';
import { Helmet } from 'react-helmet-async';

const PageTitle = ({ title }) => (
    <Helmet>
        <title>{title} | GEMHSMED</title>
    </Helmet>
);

export default PageTitle;